﻿import axios from 'src/api/axiosConfig'
import type { ApiResponse } from 'src/types/apiTypes'
import type { RoutineModel, SetRoutineCompleteRequest, UpdateExerciseCompleteRequest } from 'src/types/webContracts'
import type { AxiosResponse } from 'axios'
import { ApiRoutes } from '../ApiRoutes'

export async function getRoutine(eventId: number, languageId: number, tickSignature: string, eocId?: number | null): Promise<AxiosResponse<ApiResponse<RoutineModel>>> {
  const response = await axios.get(ApiRoutes.Routine.GetRoutine, { params: { eventId, languageId, tickSignature, eocId } });
  return response;
}

export async function updateExerciseCompletion(model: UpdateExerciseCompleteRequest): Promise<AxiosResponse<ApiResponse<string>>> {
  const response = await axios.post(ApiRoutes.Routine.UpdateExerciseCompletion, model)
  return response;
}

export async function setRoutineComplete(model: SetRoutineCompleteRequest): Promise<AxiosResponse<ApiResponse<string>>> {
  const response = await axios.post(ApiRoutes.Routine.SetRoutineCompleteRequest, model)
  return response;
}
